/* eslint-disable max-len */
import { HealthSurveillanceQuestionConfig, MedicalTypeId, MedicalTypeIds } from "../models";

import * as questionIds from "./questionIds";

const FieldForceMedicals: MedicalTypeId[] = [
    MedicalTypeIds.FieldForce,
];

/**
 * @deprecated Prefer sections exported from `import { sections } from "../questionnaire";` which is in a data structure suitable for use with custom medicals
 */
export const section15Questions: HealthSurveillanceQuestionConfig[] = [
    {
        id: questionIds.IfYesHaveOngoingSymptomsOrMedicationBeenOngoingForMoreThan12Months,
        questionText: "If you have answered yes to any of the previous questions, are these ongoing symptoms, diagnosis or treatments (including medication) been ongoing for longer than 12 months?",
        medicalTypes: FieldForceMedicals
    },
    {
        id: questionIds.IfYesHaveOngoingSymptomsOrMedicationBeenOngoingForMoreThan12MonthsFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: FieldForceMedicals
    },
    {
        id: questionIds.HasThereBeenAnyChangeToVisionOrOngoingMedicalConditionSinceLastQuestionnaire,
        questionText: "Has there been any change to your vision or the ongoing medical condition, symptoms or to your treatment (including medication) since your last questionnaire?",
        medicalTypes: FieldForceMedicals
    },
    {
        id: questionIds.HasThereBeenAnyChangeToVisionOrOngoingMedicalConditionSinceLastQuestionnaireFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: FieldForceMedicals
    },
    {
        id: questionIds.AreAnySymptomsOrMedicationNewWithinLast12MonthsFieldForce,
        questionText: "Are the symptoms, diagnosis or medication new within the last 12 months?",
        medicalTypes: FieldForceMedicals
    },
    {
        id: questionIds.AreAnySymptomsOrMedicationNewWithinLast12MonthsFieldForceFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: FieldForceMedicals
    }
];
/* eslint-restore max-len */
